import { render, staticRenderFns } from "./floor-7-Item.vue?vue&type=template&id=61b4d074&scoped=true&"
import script from "./floor-7-Item.vue?vue&type=script&lang=js&"
export * from "./floor-7-Item.vue?vue&type=script&lang=js&"
import style0 from "./floor-7-Item.vue?vue&type=style&index=0&id=61b4d074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b4d074",
  null
  
)

component.options.__file = "floor-7-Item.vue"
export default component.exports